import onArchiveTeam from './onArchiveTeam';
import onCreateTeam from './onCreateTeam';
import onRestoreTeam from './onRestoreTeam';
import onUpdateTeam from './onUpdateTeam';

export default { onArchiveTeam, onCreateTeam, onRestoreTeam, onUpdateTeam };
